var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromocodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5L12.5 7.5",
    stroke: "#1A1919",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 8.33333C8.14679 8.33333 8.33333 8.14679 8.33333 7.91667C8.33333 7.68655 8.14679 7.5 7.91667 7.5C7.68655 7.5 7.5 7.68655 7.5 7.91667C7.5 8.14679 7.68655 8.33333 7.91667 8.33333Z",
    fill: "#1A1919",
    stroke: "#1A1919",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 12.5013C12.3135 12.5013 12.5 12.3148 12.5 12.0846C12.5 11.8545 12.3135 11.668 12.0833 11.668C11.8532 11.668 11.6667 11.8545 11.6667 12.0846C11.6667 12.3148 11.8532 12.5013 12.0833 12.5013Z",
    fill: "#1A1919",
    stroke: "#1A1919",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 6.00038C4.16667 5.51415 4.35982 5.04784 4.70364 4.70402C5.04746 4.36021 5.51377 4.16705 6 4.16705H6.83334C7.31742 4.16677 7.78174 3.97505 8.125 3.63372L8.70834 3.05038C8.87871 2.87905 9.08127 2.74309 9.30437 2.65031C9.52747 2.55753 9.76671 2.50977 10.0083 2.50977C10.25 2.50977 10.4892 2.55753 10.7123 2.65031C10.9354 2.74309 11.138 2.87905 11.3083 3.05038L11.8917 3.63372C12.2349 3.97505 12.6993 4.16677 13.1833 4.16705H14.0167C14.5029 4.16705 14.9692 4.36021 15.313 4.70402C15.6568 5.04784 15.85 5.51415 15.85 6.00038V6.83372C15.8503 7.3178 16.042 7.78213 16.3833 8.12538L16.9667 8.70872C17.138 8.87909 17.274 9.08165 17.3667 9.30475C17.4595 9.52785 17.5073 9.76709 17.5073 10.0087C17.5073 10.2503 17.4595 10.4896 17.3667 10.7127C17.274 10.9358 17.138 11.1383 16.9667 11.3087L16.3833 11.8921C16.042 12.2353 15.8503 12.6996 15.85 13.1837V14.0171C15.85 14.5033 15.6568 14.9696 15.313 15.3134C14.9692 15.6572 14.5029 15.8504 14.0167 15.8504H13.1833C12.6993 15.8507 12.2349 16.0424 11.8917 16.3837L11.3083 16.9671C11.138 17.1384 10.9354 17.2743 10.7123 17.3671C10.4892 17.4599 10.25 17.5077 10.0083 17.5077C9.76671 17.5077 9.52747 17.4599 9.30437 17.3671C9.08127 17.2743 8.87871 17.1384 8.70834 16.9671L8.125 16.3837C7.78174 16.0424 7.31742 15.8507 6.83334 15.8504H6C5.51377 15.8504 5.04746 15.6572 4.70364 15.3134C4.35982 14.9696 4.16667 14.5033 4.16667 14.0171V13.1837C4.16639 12.6996 3.97467 12.2353 3.63334 11.8921L3.05 11.3087C2.87867 11.1383 2.7427 10.9358 2.64993 10.7127C2.55715 10.4896 2.50938 10.2503 2.50938 10.0087C2.50938 9.76709 2.55715 9.52785 2.64993 9.30475C2.7427 9.08165 2.87867 8.87909 3.05 8.70872L3.63334 8.12538C3.97467 7.78213 4.16639 7.3178 4.16667 6.83372V6.00038",
    stroke: "#1A1919",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocodes);
export default __webpack_public_path__ + "static/media/promocodes.e2714cc9fdbc91ddee305f1c8f1625f6.svg";
export { ForwardRef as ReactComponent };